/* eslint-disable react/prefer-stateless-function */

import React, {Component, PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {getToggleLabel} from '../../../user/shared/services/user-settings-helpers';
import {translate} from '../../../shared/services/translation-service';

class DealerRecommendationHandlers extends Component {

    render() {

        return (

            <div>
                <div className='select-review-request-button'>
                    {this.props.dealerRecommendations.length ?
                        <button
                            onClick={this.props.selectAllActionHandler}
                            type='button'
                        >
                            <FormattedMessage id={getToggleLabel(this.props.selectedDealerRecommendations)}/>
                        </button> : null}

                    <button
                        className='button-primary'
                        disabled={this.props.selectedDealerRecommendations.length}
                        onClick={() => this.props.openDealerRecommendationModal(translate('TRANSFER_DEALER_RECOMMENDATIONS'), translate('TRANSFER_ALL'), 'transferAll')}
                    >
                        <FormattedMessage id='TRANSFER_ALL'/>
                    </button>
                    <button
                        className='button-secondary'
                        disabled={!this.props.selectedDealerRecommendations.length}
                        onClick={() => this.props.openDealerRecommendationModal(translate('REVIEW_DEALER_RECOMMENDATIONS'), translate('MARK_AS_REVIEW'), 'review')}
                    >
                        <FormattedMessage id='MARK_AS_REVIEW'/>
                    </button>
                    <button
                        className='button-primary'
                        disabled={!this.props.selectedDealerRecommendations.length}
                        onClick={() => this.props.openDealerRecommendationModal(translate('TRANSFER_DEALER_RECOMMENDATIONS'), translate('CREATE_REQUEST'), 'transfer')}
                    >
                        <FormattedMessage id='CREATE_REQUEST'/>
                    </button>
                </div>

            </div>);

    }
}

DealerRecommendationHandlers.displayName = 'DealerRecommendationHandlers';
DealerRecommendationHandlers.propTypes = {
    dealerRecommendations: PropTypes.instanceOf(Array).isRequired,
    openDealerRecommendationModal: PropTypes.func.isRequired,
    selectAllActionHandler: PropTypes.func.isRequired,
    selectedDealerRecommendations: PropTypes.instanceOf(Array).isRequired
};

export default DealerRecommendationHandlers;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation-handlers.js